import style from './index.module.scss';

type TFooterDots = { selected: number };

export const FooterDots = ({ selected }: TFooterDots) => {
  return (
    <div className={style.footerDots}>
      {new Array(4).fill('').map((value, index) => (
        <div
          key={`dots-${index}`}
          className={index === selected ? style.main : ''}
        ></div>
      ))}
    </div>
  );
};
